module.exports = __webpack_public_path__ + "images/discover-author_Ned.jpg";